import { ShieldQuestion } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

/**
 * For a session that can reach nothing at all — `resolveLandingPath` returned `null`.
 *
 * Distinct from `NoAccessView` on purpose. That one answers "you cannot open THIS section" and offers a way
 * back; here there is no back, and telling someone they lack permission for a page they never asked for is
 * misleading. The right message is that the account is waiting on an assignment, and who to ask.
 *
 * No action button: every destination is closed, so any button would be a dead end.
 */
export const NoNavigationAccessView = () => {
  const { t } = useTranslations("global");

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-12 text-center">
      <div className="rounded-full bg-slate-100 dark:bg-slate-800 p-4 mb-6">
        <ShieldQuestion className="h-12 w-12 text-slate-500 dark:text-slate-400" />
      </div>
      <h2 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white mb-2">
        {t("no_navigation_access_title")}
      </h2>
      <p className="text-gray-600 dark:text-gray-400 max-w-md">{t("no_navigation_access_description")}</p>
    </div>
  );
};
